import React from 'react'
// libs
import styled from 'styled-components'
import { Field } from 'redux-form'
// components
import FormControl from '@mui/material/FormControl'
import InputLabel from 'components/FormElements/components/InputLabel'
import SliderComponent from 'components/FormElements/Slider'
import ErrorMessage, { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// types
import { SliderProps } from '@mui/material/Slider'
import { WrappedFieldProps } from 'redux-form/lib/Field'
// utils
import { pipe, round } from 'lodash/fp'

const ReduxSliderWrapper = styled(FormControl)`
  && {
    position: relative;
  }
`

const Slider = styled(SliderComponent)`
  && {
    margin-top: 32px;
  }
`

interface Props extends Omit<SliderProps, 'ref' | 'onChange'> {
  name: string
  label?: string
}

const renderComponent = ({ name, label, input, meta, ...rest }: Props & WrappedFieldProps) => {
  const { error, touched } = meta

  const handleSliderChange = (_: Event, value: number | number[]) => {
    input.onChange(value)
  }

  const handleChangeCommitted = (_: React.MouseEvent, value: number | number[]) => {
    input.onBlur(value)
  }

  const value = pipe(parseFloat, round)(input.value)

  return (
    <ReduxSliderWrapper margin='none' fullWidth error={touched && !!error}>
      <InputLabel shrink htmlFor={name} variant={'standard'} filled error={touched && error}>
        {label} ({value}%)
      </InputLabel>
      <Slider
        step={1}
        value={value}
        onChange={handleSliderChange}
        onChangeCommitted={handleChangeCommitted}
        {...rest}
      />
      {touched && error && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxSliderWrapper>
  )
}

const ReduxSlider: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxSlider
